import React, { ReactElement } from 'react';
import { SxProps, Theme } from '@mui/material';
import { IComponentCss } from '@tap/mui-ui';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';

/*
*   Кнопка - открытие выпадающего меню
*/

type IDropdownMenuOpenButton = {
    primaryText: string | undefined,
    secondaryText?: string | undefined,
    maxWidth?: string,
    minWidth?: string,
    width?: string,
    fullWidth?: boolean,
    justifyContent?: string,
    startIcon?: ReactElement<any, any>,
    endIcon?: ReactElement<any, any>,
    margin?: string,
    sxButton?: SxProps<Theme>,
    handleClick: (
        event: React.MouseEvent<HTMLButtonElement>,
        selectedItem?: number | string | undefined
    ) => void,
}

const css: IComponentCss = {
    typography: {
        lineHeight: '1.3',
        textAlign: 'left',
        float: 'left',
        left: '0px',
        textTransform: 'none',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        color: '#666666',
    },
}


export function DropdownMenuOpenButton({
    primaryText, secondaryText, maxWidth = '120px', minWidth = 'max-content',
    width = 'auto', startIcon, fullWidth = true, endIcon, justifyContent = 'center',
    margin = '', sxButton = {}, handleClick,
}: IDropdownMenuOpenButton) {

    return (
        <Button
            color='inherit'
            onClick={handleClick}
            startIcon={!!startIcon && startIcon}
            fullWidth={fullWidth}
            endIcon={!!endIcon && endIcon}
            sx={{
                minWidth: minWidth,
                width: width,
                justifyContent: justifyContent,
                margin: margin,
                ...sxButton,
            }}
        >
            <Typography
                sx={{
                    ...css.typography,
                    maxWidth: maxWidth,
                }}
            >
                {primaryText}
                {!!secondaryText && <> <br />{secondaryText} </>}
            </Typography>
        </Button>
    );
}
